import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const blogService = {
  // Get all posts with pagination
  async getPosts({ page = 1, perPage = 10, category = null, featured = null, publishedOnly = true } = {}) {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('per_page', perPage);
    params.append('published_only', publishedOnly);
    if (category) params.append('category', category);
    if (featured !== null) params.append('featured', featured);

    const response = await axios.get(`${API_URL}/api/blog?${params.toString()}`);
    return response.data;
  },

  // Get single post by slug
  async getPostBySlug(slug) {
    const response = await axios.get(`${API_URL}/api/blog/${slug}`);
    return response.data;
  },

  // Get all categories
  async getCategories() {
    const response = await axios.get(`${API_URL}/api/blog/categories`);
    return response.data.categories;
  },

  // Create a new post (admin)
  async createPost(postData) {
    const response = await axios.post(`${API_URL}/api/blog`, postData);
    return response.data;
  },

  // Update a post (admin)
  async updatePost(postId, postData) {
    const response = await axios.put(`${API_URL}/api/blog/${postId}`, postData);
    return response.data;
  },

  // Delete a post (admin)
  async deletePost(postId) {
    const response = await axios.delete(`${API_URL}/api/blog/${postId}`);
    return response.data;
  },

  // Get all posts for admin (including unpublished)
  async getAdminPosts({ page = 1, perPage = 20 } = {}) {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('per_page', perPage);
    params.append('published_only', false);

    const response = await axios.get(`${API_URL}/api/blog?${params.toString()}`);
    return response.data;
  }
};
